import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { api } from "@/lib/api";

const setBannerHeight = (px) => {
  try { document.documentElement.style.setProperty("--promo-h", `${px}px`); } catch (e) {}
};

// Дней до конца акции (включая сегодняшний день). null = без даты.
const daysLeft = (until) => {
  if (!until) return null;
  const [y, m, d] = until.split("-").map(Number);
  if (!y || !m || !d) return null;
  const end = new Date(y, m - 1, d, 23, 59, 59);
  const now = new Date();
  const ms = end - now;
  if (ms < 0) return -1;
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((new Date(y, m - 1, d) - today) / 86400000);
};

export const PromoBanner = () => {
  const [s, setS] = useState(null);
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => setS(r.data)).catch(() => {});
  }, []);

  const left = s ? daysLeft(s.promo_until) : null;
  const key = s ? `promo_closed_${s.promo_text}_${s.promo_until}` : "";
  const visible = !!(s && s.promo_enabled && s.promo_text && left !== -1 && !closed);

  useEffect(() => {
    if (!key) return;
    try { if (sessionStorage.getItem(key)) setClosed(true); } catch (e) {}
  }, [key]);

  useEffect(() => {
    setBannerHeight(visible ? 40 : 0);
    return () => setBannerHeight(0);
  }, [visible]);

  if (!visible) return null;

  const close = () => {
    setClosed(true);
    try { sessionStorage.setItem(key, "1"); } catch (e) {}
  };

  let countdown = "";
  if (left === 0) countdown = "nur noch heute!";
  else if (left === 1) countdown = "noch 1 Tag";
  else if (left > 1) countdown = `noch ${left} Tage`;

  const link = s.promo_link || "/apartments";
  const content = (
    <span className="truncate">
      <span className="font-semibold">{s.promo_text}</span>
      {countdown && <span className="text-[var(--gold)] font-medium"> · {countdown}</span>}
      <span className="hidden sm:inline text-[var(--gold)] underline underline-offset-2 ml-3">Jetzt buchen →</span>
    </span>
  );

  return (
    <div data-testid="promo-banner"
      className="fixed top-0 left-0 right-0 z-[60] h-10 bg-[var(--sage)] text-white text-[13px] sm:text-sm flex items-center justify-center px-10">
      {link.startsWith("/")
        ? <Link to={link} className="flex items-center justify-center min-w-0">{content}</Link>
        : <a href={link} className="flex items-center justify-center min-w-0">{content}</a>}
      <button onClick={close} aria-label="Schließen"
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded-full hover:bg-white/20">
        <X size={14} />
      </button>
    </div>
  );
};
